/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AlertsResponseDto,
  UserBodyDto,
  UserDto,
  UserUpdateBodyDto,
  UsersFindAllParams,
  UsersResponseDto,
} from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get current user information
 */
export const Users_getMe = (
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<UserDto>(
    { url: `/api/users/me`, method: 'GET', signal },
    options,
  );
};

export const getUsersGetMeQueryKey = () => {
  return ['api', 'users', 'me'] as const;
};

export const getUsersGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof Users_getMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof Users_getMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Users_getMe>>> = ({
    signal,
  }) => Users_getMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Users_getMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersGetMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof Users_getMe>>
>;
export type UsersGetMeQueryError = unknown;

export function useUsersGetMe<
  TData = Awaited<ReturnType<typeof Users_getMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_getMe>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_getMe>>,
          TError,
          Awaited<ReturnType<typeof Users_getMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersGetMe<
  TData = Awaited<ReturnType<typeof Users_getMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_getMe>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_getMe>>,
          TError,
          Awaited<ReturnType<typeof Users_getMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersGetMe<
  TData = Awaited<ReturnType<typeof Users_getMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_getMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user information
 */

export function useUsersGetMe<
  TData = Awaited<ReturnType<typeof Users_getMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_getMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersGetMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all alerts for current user
 */
export const Users_getMyAlerts = (
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<AlertsResponseDto>(
    { url: `/api/users/me/alerts`, method: 'GET', signal },
    options,
  );
};

export const getUsersGetMyAlertsQueryKey = () => {
  return ['api', 'users', 'me', 'alerts'] as const;
};

export const getUsersGetMyAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof Users_getMyAlerts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof Users_getMyAlerts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetMyAlertsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Users_getMyAlerts>>
  > = ({ signal }) => Users_getMyAlerts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Users_getMyAlerts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersGetMyAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof Users_getMyAlerts>>
>;
export type UsersGetMyAlertsQueryError = unknown;

export function useUsersGetMyAlerts<
  TData = Awaited<ReturnType<typeof Users_getMyAlerts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Users_getMyAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_getMyAlerts>>,
          TError,
          Awaited<ReturnType<typeof Users_getMyAlerts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersGetMyAlerts<
  TData = Awaited<ReturnType<typeof Users_getMyAlerts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Users_getMyAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_getMyAlerts>>,
          TError,
          Awaited<ReturnType<typeof Users_getMyAlerts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersGetMyAlerts<
  TData = Awaited<ReturnType<typeof Users_getMyAlerts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Users_getMyAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all alerts for current user
 */

export function useUsersGetMyAlerts<
  TData = Awaited<ReturnType<typeof Users_getMyAlerts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Users_getMyAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersGetMyAlertsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all users with pagination and filters
 */
export const Users_findAll = (
  params?: UsersFindAllParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<UsersResponseDto>(
    { url: `/api/users`, method: 'GET', params, signal },
    options,
  );
};

export const getUsersFindAllQueryKey = (params?: UsersFindAllParams) => {
  return ['api', 'users', ...(params ? [params] : [])] as const;
};

export const getUsersFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof Users_findAll>>,
  TError = unknown,
>(
  params?: UsersFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_findAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersFindAllQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Users_findAll>>> = ({
    signal,
  }) => Users_findAll(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Users_findAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof Users_findAll>>
>;
export type UsersFindAllQueryError = unknown;

export function useUsersFindAll<
  TData = Awaited<ReturnType<typeof Users_findAll>>,
  TError = unknown,
>(
  params: undefined | UsersFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_findAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_findAll>>,
          TError,
          Awaited<ReturnType<typeof Users_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersFindAll<
  TData = Awaited<ReturnType<typeof Users_findAll>>,
  TError = unknown,
>(
  params?: UsersFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_findAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Users_findAll>>,
          TError,
          Awaited<ReturnType<typeof Users_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersFindAll<
  TData = Awaited<ReturnType<typeof Users_findAll>>,
  TError = unknown,
>(
  params?: UsersFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_findAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all users with pagination and filters
 */

export function useUsersFindAll<
  TData = Awaited<ReturnType<typeof Users_findAll>>,
  TError = unknown,
>(
  params?: UsersFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Users_findAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersFindAllQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new user
 */
export const Users_create = (
  userBodyDto: UserBodyDto,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<UserDto>(
    {
      url: `/api/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userBodyDto,
      signal,
    },
    options,
  );
};

export const getUsersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Users_create>>,
    TError,
    { data: UserBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Users_create>>,
  TError,
  { data: UserBodyDto },
  TContext
> => {
  const mutationKey = ['usersCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Users_create>>,
    { data: UserBodyDto }
  > = (props) => {
    const { data } = props ?? {};

    return Users_create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof Users_create>>
>;
export type UsersCreateMutationBody = UserBodyDto;
export type UsersCreateMutationError = unknown;

/**
 * @summary Create a new user
 */
export const useUsersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Users_create>>,
      TError,
      { data: UserBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Users_create>>,
  TError,
  { data: UserBodyDto },
  TContext
> => {
  const mutationOptions = getUsersCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update an user
 */
export const Users_update = (
  userId: string,
  userUpdateBodyDto: UserUpdateBodyDto,
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<UserDto>(
    {
      url: `/api/users/${userId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: userUpdateBodyDto,
    },
    options,
  );
};

export const getUsersUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Users_update>>,
    TError,
    { userId: string; data: UserUpdateBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Users_update>>,
  TError,
  { userId: string; data: UserUpdateBodyDto },
  TContext
> => {
  const mutationKey = ['usersUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Users_update>>,
    { userId: string; data: UserUpdateBodyDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return Users_update(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof Users_update>>
>;
export type UsersUpdateMutationBody = UserUpdateBodyDto;
export type UsersUpdateMutationError = void;

/**
 * @summary Update an user
 */
export const useUsersUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Users_update>>,
      TError,
      { userId: string; data: UserUpdateBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Users_update>>,
  TError,
  { userId: string; data: UserUpdateBodyDto },
  TContext
> => {
  const mutationOptions = getUsersUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete an user
 */
export const Users_remove = (
  userId: string,
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<void>(
    { url: `/api/users/${userId}`, method: 'DELETE' },
    options,
  );
};

export const getUsersRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Users_remove>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Users_remove>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['usersRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Users_remove>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return Users_remove(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof Users_remove>>
>;

export type UsersRemoveMutationError = unknown;

/**
 * @summary Delete an user
 */
export const useUsersRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Users_remove>>,
      TError,
      { userId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Users_remove>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getUsersRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
